module.exports = __webpack_public_path__ + "img/404.307f4d2a.png";